import requst from './request';

export const getUserInfo = () => requst.post("/getUserLoginInfo");
